<template>
  <div
    class="input-container"
    :class="{ 'required-fail': requiredFail }"
    style="position: relative"
  >
    <input
      type="date"
      :disabled="disabled"
      :value="getDate"
      @input="updateDate($event.target.value)"
    />

    <v-btn
      v-if="!disabled && !required && value"
      @click="updateValue(null)"
      x-small
      text
      icon
      class="form-input-clear-button"
    >
      <v-icon size="15">
        clear
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { inputTypeMixin } from "@/mixins/forms/dynamicObjectForms/inputTypeMixin";

export default {
  name: "InputTypeDate",

  mixins: [inputTypeMixin],

  props: {
    required: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    //input was not reading when the date was sent from mobile to BE, receives value turns it into a new date, then converts in date readable format.
    getDate() {
      if (this.value) {
        let date = new Date(this.value);
        let month = date.toISOString().substring(0, 10);
        return month;
      } else return null;
    }
  },

  //input was not reading when the date was sent from mobile to BE, receives value turns it into a new date, then converts in date readable format.

  mounted() {},

  methods: {
    updateDate(e) {
      this.updateValue(e);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/InputTypes/InputTypeDate.vue